// Các màn dùng token trong link email: xác minh email · đặt lại mật khẩu · quên mật khẩu.
import { Button, Field } from "@secretaa/ui";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router";
import { api } from "../../app/api.ts";
import { errorMessage } from "../../shared/errors.ts";
import { Form, FormError, Notice } from "../../shared/form.tsx";

export function VerifyEmailPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const [state, setState] = useState<"working" | "done" | { error: string }>("working");
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return; // StrictMode gọi effect 2 lần: token chỉ dùng được MỘT lần
    started.current = true;
    void (async () => {
      try {
        await api.csrf();
        await api.auth.verifyEmail(params.get("token") ?? "");
        setState("done");
      } catch (e) {
        setState({ error: errorMessage(t, e) });
      }
    })();
  }, [params, t]);
  return (
    <>
      <h1 className="mb-4 text-xl font-semibold">{t("auth.verify.title")}</h1>
      {state === "working" ? <p>{t("auth.verify.working")}</p> : state === "done" ? <Notice>{t("auth.verify.done")}</Notice> : <FormError message={state.error} />}
      <p className="mt-4 text-sm">
        <Link className="underline" to="/login">
          {t("auth.verify.toLogin")}
        </Link>
      </p>
    </>
  );
}

export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (done) return <Notice>{t("auth.forgot.done")}</Notice>;
  return (
    <>
      <h1 className="mb-4 text-xl font-semibold">{t("auth.forgot.title")}</h1>
      <Form
        label={t("auth.forgot.title")}
        onSubmit={async () => {
          try {
            await api.csrf();
            await api.auth.forgotPassword(email);
            setDone(true);
          } catch (e) {
            setError(errorMessage(t, e));
          }
        }}
      >
        <FormError message={error} />
        <Field label={t("auth.fields.email")} type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        <Button type="submit">{t("auth.forgot.submit")}</Button>
      </Form>
    </>
  );
}

export function ResetPasswordPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (done)
    return (
      <>
        <Notice>{t("auth.reset.done")}</Notice>
        <p className="mt-4 text-sm">
          <Link className="underline" to="/login">
            {t("auth.verify.toLogin")}
          </Link>
        </p>
      </>
    );
  return (
    <>
      <h1 className="mb-4 text-xl font-semibold">{t("auth.reset.title")}</h1>
      <Form
        label={t("auth.reset.title")}
        onSubmit={async () => {
          try {
            await api.csrf();
            await api.auth.resetPassword(params.get("token") ?? "", password);
            setDone(true);
          } catch (e) {
            setError(errorMessage(t, e));
          }
        }}
      >
        <FormError message={error} />
        <Field label={t("auth.fields.newPassword")} type="password" autoComplete="new-password" minLength={10} hint={t("auth.register.passwordHint")} required value={password} onChange={(e) => setPassword(e.target.value)} />
        <Button type="submit">{t("auth.reset.submit")}</Button>
      </Form>
    </>
  );
}
